// Helper for emitting Google Analytics 4 events from anywhere in the app.
// Falls back to a no-op when gtag is not available (preview, dev, ad-blockers).
export function trackEvent(name, params = {}) {
  try {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    window.gtag("event", name, params);
  } catch {
    // never let analytics throw at the call site
  }
}
